Librarian.Modules.HTML = new Class({
    Extends: Librarian.Modules.Module,

    options: {
        classPrefix: "modules-html-",
        fileName: null,
        html: null,
        htmlFile: null,
        callback: null,
        onClick: null,
        clickEnabled: null,
        popupHeight: 350,
        editable: false,
    },

    title: null,
    html: null,
    editor: null,

    initialize: function (options, wrapperEl) {
        this.setOptions(options);
        var self = this;
        if (this.options.clickEnabled == "true") {
            this.options.onClick = function () {
                var windowPopup = new Librarian.Popup({ htmlFile: "popup.html", height: self.options.popupHeight, useIframe: false });
            };
        }

        // add click handler to module
        if (this.options.onClick)
            wrapperEl.addOnClick(this.options.onClick);

        this.parent(this.options, wrapperEl);
    },

    load: function () {
        if (!this.wrapperEl || (!this.options.fileName && !this.options.html && !this.options.htmlFile))
            return;

        this.parent();

        if (typeof this.options.fileName == "string") {
            // Generate the URL
            var url = Librarian.path.getMethodUrl("getslidetext") + "&out=ujson&snum=1&fname=" + encodeURIComponent(this.options.fileName);

            this.request = new Librarian.Request.JSON({
                url: url,
                onSuccess: function (json) {
                    if (!json)
                        return;

                    this.onLoadHtml(json.Text);
                }.bind(this),
                onFailure: Librarian.Utils.onFailure
            });
            this.request.send();
        }
        else if (typeof this.options.htmlFile == "string") {
            this.request = new Librarian.Request.HTML({
                url: this.options.htmlFile,
                onSuccess: function (nodes, elements, html) {
                    if (!html)
                        return;

                    this.onLoadHtml(html);
                }.bind(this)
            }).send();
        }
        else if (typeof this.options.html == "string")
            this.onLoadHtml(this.options.html);
    },

    onLoadHtml: function (html) {
        this.html = html;
        this.setHtml(html);

        if (this.options.editable && Librarian.Utils.isUserMemberOfGroup("Administrators"))
            this.setupEditor();

        if (typeof this.options.callback == "function")
            this.options.callback(this.containerEl);
    },

    setHtml: function (html) {
        this.containerEl.set("html", html);
    },

    // #region Editing

    setupEditor: function () {
        // Remove any editors that were previously using this ID, to prevent collisions
        if (this.containerEl.id)
            tinyMCE.remove("#" + this.containerEl.id);

        var options = Librarian.Utils.getTinyMCEOptions({
            target: this.containerEl,
            plugins: "lists advlist code link image hr", // casechange checklist formatpainter", TODO Add these if we purchase the plugins
            toolbar: "fontfamily bold italic underline forecolor backcolor fontsize | alignleft aligncenter alignright indent outdent bullist numlist | link insertimage removeformat code",
            inline: true,
            setup: function (editor) {
                this.editor = editor;

                Librarian.Utils.addTinyMCEButton(editor, "insertimage");
                editor.on("init", function () {
                    editor.hide();
                });
            }.bind(this)
        });

        tinyMCE.init(options);

        this.setupEditButtons();
    },

    setupEditButtons: function () {
        if (!this.headerEl)
            return;

        var buttonCont = new Element("div", {
            "class": this.options.classPrefix + "edit-buttons"
        }).injectInside(this.headerEl);

        var editButton = new Element("span", {
            "class": this.options.classPrefix + "edit ico-edit"
        }).injectInside(buttonCont)
            .addOnClick(this.edit, this);

        var cancelButton = new Element("span", {
            "class": this.options.classPrefix + "cancel ico-cancel"
        }).injectInside(buttonCont)
            .addOnClick(this.cancel, this);

        var saveButton = new Element("span", {
            "class": this.options.classPrefix + "save ico-save"
        }).injectInside(buttonCont)
            .addOnClick(this.save, this);
    },

    edit: function () {
        this.enableEditing();

        if (this.titleEl)
            this.title = this.titleEl.get("text");
    },

    cancel: function () {
        this.disableEditing();

        this.setHtml(this.html);
        if (this.titleEl)
            this.titleEl.set("text", this.title);
    },

    save: function () {
        this.disableEditing();

        this.html = this.containerEl.get("html");
        if (this.titleEl)
            this.title = this.titleEl.get("text");

        if (this.options.eventHandler) {
            var data = {
                title: this.title,
                html: this.html
            }

            this.options.eventHandler.fireEvent("updateModule", [this, "HTML", data]);
        }
    },

    enableEditing: function () {
        this.wrapperEl.addClass("editing");
        this.editor.show();

        if (this.titleEl)
            this.titleEl.set("contenteditable", "true");
    },

    disableEditing: function () {
        this.wrapperEl.removeClass("editing");
        this.editor.hide();

        if (this.titleEl)
            this.titleEl.set("contenteditable", "false");
    }

    // #endregion
});